<template>
  <v-row>
    <v-col cols="12">
      <v-form ref="form">
        <base-card>
          <v-card-title>Registrar Credenciales TEF</v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                sm="3"
              >
                <v-text-field
                  ref="Cliente"
                  v-model="dataCredentials.client"
                  label="Cliente (Razón Social)"
                  prepend-inner-icon="mdi-account-tie"
                  :rules="formRules"
                  clearable
                  required
                />
              </v-col>
              <v-col
                cols="12"
                sm="3"
              >
                <v-select
                  ref="rol"
                  v-model="dataCredentials.typeTef"
                  :items="typeTef"
                  :rules="formRules"
                  item-text="textCredential"
                  item-value="valueCredential"
                  label="Tipo Tef"
                  prepend-inner-icon="mdi-printer-pos"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                sm="1"
              >
                <br>
                <v-icon
                  class="mr-2"
                  color="green darken-3"
                  style="cursor: pointer"
                  @click="downloadFormatExcel(dataCredentials.typeTef)"
                >
                  mdi-microsoft-excel
                </v-icon>
              </v-col>
              <v-col
                cols="12"
                sm="3"
              >
                <v-file-input
                  id="aExcel"
                  :rules="formRules"
                  @change="loadExcel()"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="4"
              >
                <v-btn
                  class="ma-2"
                  style="background-color:rgb(204 33 40);color:white !important"
                  @click="validateCredentialsToInsertThem"
                >
                  Importar Credenciales
                </v-btn>
              </v-col>
            </v-row>
            <v-row
              v-if="importCredentialsProgress === true"
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-col cols="6">
                <v-col
                  class="text-subtitle-1 text-center"
                  cols="12"
                >
                  Procesando y Guardando Credenciales
                </v-col>
                <v-progress-linear
                  color="red darken-4"
                  indeterminate
                  rounded
                  height="6"
                />
              </v-col>
            </v-row>
            <v-alert
              v-show="successAlert"
              type="success"
              text
            >
              {{ msgSuccessAlert }}
            </v-alert>
            <v-alert
              v-show="warningAlert"
              type="warning"
              text
            >
              {{ msgWarningAlert }}
            </v-alert>
          </v-card-text>
        </base-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
  import { listTef } from '@/data/listTef'
  import readXlsFile from 'read-excel-file'
  import { mapState } from 'vuex'

  export default {
    name: 'RegisterCredentialTef',

    data () {
      return {
        items: [],
        importCredentialsProgress: false,
        setDataCredentials: [],
        permisosRoles: ['administrador'],
        dataCredentials: {},
        typeTef: listTef,
        successAlert: false,
        warningAlert: false,
        msgSuccessAlert: '',
        msgWarningAlert: '',
        formHasErrors: null,
        formRules: [
          (v) => !!v || 'Este campo es requerido',
        ],
      }
    },
    computed: {
      ...mapState('credentialsTef', ['statusResponse']),
    },
    watch: {
      statusResponse () {
        this.importCredentialsProgress = false
        const msg = this.$store.state.credentialsTef.statusResponse.Mensaje

        if (!this.$store.state.credentialsTef.statusResponse.Error) {
          this.msgSuccessAlert = msg
          this.successAlert = true
          this.clearForm()
          setTimeout(() => {
            this.successAlert = false
          }, 6000)
        } else {
          this.msgWarningAlert = msg
          this.warningAlert = true
          setTimeout(() => {
            this.warningAlert = false
          }, 6000)
        }
        this.$store.dispatch('credentialsTef/getListCredentials')
      },
      formHasErrors () {
        if (this.formHasErrors === false) {
          this.sendCredentials()
        }
      },
    },
    methods: {
      clearForm () {
        this.formHasErrors = null
        this.$refs.form.reset()
      },
      loadExcel () {
        const input = document.getElementById('aExcel')
        readXlsFile(input.files[0]).then((rows) => {
          this.items = rows
        })
      },
      sendCredentials () {
        this.importCredentialsProgress = true
        if (this.dataCredentials.typeTef === '1' || this.dataCredentials.typeTef === '2') {
          this.buildCredentialPinpadDatafast()
        } else {
          this.importCredentialsProgress = false
        }
      },

      buildCredentialPinpadDatafast () {
        this.items.forEach((column, index) =>

          column.forEach(() =>
            this.setDataCredentials[index] = {
              IdCompania: JSON.parse(atob(localStorage.getItem('uid'))).idcompania,
              client: this.dataCredentials.client,
              type_tef: this.dataCredentials.typeTef,
              data_integration: {
                code_store: column[0],
                mid: column[1],
                tid: column[2],
                cid: column[3],
                lote: column[4],
                referencia: column[5],
                ip_pinpad: column[6],
                puerto: column[7],
                mascara: column[8],
                gateway: column[9],
              },
              user: JSON.parse(atob(localStorage.getItem('uid'))).user,
            },
          ),
        )

        this.insertCredentials(this.setDataCredentials)
      },

      async insertCredentials (dataCredentials) {
        await this.$store.dispatch('credentialsTef/insertCredentials', { credentials: dataCredentials })
      },

      downloadFormatExcel (typeTef) {
        let format
        if (typeTef === '1') {
          format = 'formato/PinPadDatafast'
        } else if (typeTef === '2') {
          format = 'formato/PinPadMedianet'
        }
        const linkSource = '/' + format + '.xlsx'
        const downloadLink = document.createElement('a')
        const fileName = format + '.xlsx'
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      },

      validateCredentialsToInsertThem () {
        this.formHasErrors = !this.$refs.form.validate()
      },
    },
  }
</script>
